import React, { useState, useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import TypingEffect from '../../utils/TypingEffect';
import './Home.css';
import { ModuleNames } from '../../Constants';
import ReactGA from 'react-ga';
import Autosuggestor from './AutoComplete'
import Unauthorized from '../Unauthorized'
import Loader from './../Loader/Loader'
import LoRRI_Image from './../../Content/images/LoRRI.png'
import Axios from '../../Axios/Axios'
import { Activity, currentRequestTimeStamp, encryptor } from '../../Constants'
import { Urls } from '../../Urls';
import { toast } from 'react-toastify';
import { UserApiContext } from '../UserDetailsContext/UserDetailsContext';

const Home = props => {
  // const [searchText, setSearchText] = useState();
  // const [country, setCountry] = useState('India');
  const [isAllowed, setisAllowed] = useState('no');
  const [show, setShow] = useState(false)
  // const [userType, setuserType] = useState('basic')
  const [submitText, setsubmitText] = useState("")
  const [audio_input, setaudio_input] = useState(false)
  // const { transcript, resetTranscript } = useSpeechRecognition()
  // const [mikeColor, setmikeColor] = useState(false)
  const { userDetails } = useContext(UserApiContext)


  useEffect(() => {
    document.title = 'LoRRI - Search Transporter'
    Activity([{
      "screen": "LoRRI-Search", "module": "Home-Search", "user_activity": "Home search page viewed", "timestamp": currentRequestTimeStamp(), "userEmail": userDetails?.email, "userName": userDetails?.user_name, companyname:userDetails.company_name
        ? userDetails.company_name
        : userDetails.email
          ? userDetails.email.split("@")[1].split(".")[0]
          : ""
    }])
    ReactGA.pageview('SearchEngine');
    setisAllowed(userDetails?.policy?.home_search && userDetails?.policy?.home_search?.allowed ? userDetails?.policy?.home_search?.allowed : 'no')
  }, [userDetails])

  const typedWords = [
    'Find your ideal transporter',
    'Save costs',
    'Improve placements',
    'De-risk your business',
    'Know industry benchmarks'
  ];

  const onSearchSubmit = (val, from) => {
    // console.log(val)
    Activity([{
      "screen": "LoRRI-Search", "module": "Home-Search", "user_activity": `Search Query: ${submitText}`, "timestamp": currentRequestTimeStamp(), "userEmail": userDetails?.email, "userName": userDetails?.user_name, companyname:userDetails.company_name
        ? userDetails.company_name
        : userDetails.email
          ? userDetails.email.split("@")[1].split(".")[0]
          : ""
    }])
    if (audio_input) {
      setaudio_input(false)
      // setsubmitText(transcript)
      var moduleNames = ModuleNames
      if (moduleNames[0].Benchmark.includes(submitText.toLowerCase())) {
        props.history.push({ pathname: '/freightrates' })
      }
      else if (moduleNames[0].CompareNow.includes(submitText.toLowerCase())) {
        props.history.push({ pathname: '/TransportComparison' })
      }
      else if (moduleNames[0].DiscoverNow.includes(submitText.toLowerCase())) {
        props.history.push({ pathname: '/DiscoverNow' })
      }
      else if (moduleNames[0].LocationDashboard.includes(submitText.toLowerCase())) {
        props.history.push({ pathname: '/location' })
      }
      else if (moduleNames[0].LogisticsNow.includes(submitText.toLowerCase())) {
        window.open(`https://www.logisticsnow.in`, "_blank")
      }
      else if (moduleNames[0].Procurement.includes(submitText.toLowerCase())) {
        window.open(`https://www.procure.lorri.in`, "_blank")

      }
      else {
        setShow(true)
        // Axios.post("https://lorrisearchv2.azurewebsites.net/api/lorrisearch", {
        Axios.post(`${Urls.search_results}`, {
          // "text": "I want transporters from mumbai"
          // "text": transcript
        })
          .then(res => {
            // console.log(res.data)
            props.history.push({
              pathname: '/SearchResults',
              state: { data: res.data.data, searchquery: submitText }
            });
            // setdata(res.data.data)
            setShow(false)
          })
          .catch(err => {
            console.log(err)
            setShow(false)
          })
      }
    }
    else {
      var moduleNames = ModuleNames
      if (moduleNames[0].Benchmark.includes(submitText.toLowerCase())) {
        props.history.push({ pathname: '/benchmarknow' })
      }
      else if (moduleNames[0].CompareNow.includes(submitText.toLowerCase())) {
        props.history.push({ pathname: '/TransportComparison' })
      }
      else if (moduleNames[0].DiscoverNow.includes(submitText.toLowerCase())) {
        props.history.push({ pathname: '/DiscoverNow' })
      }
      else if (moduleNames[0].LocationDashboard.includes(submitText.toLowerCase())) {
        props.history.push({ pathname: '/locationdashboard' })
      }
      else if (moduleNames[0].LogisticsNow.includes(submitText.toLowerCase())) {
        window.open(`https://www.logisticsnow.in`, "_blank")
      }
      else if (moduleNames[0].Procurement.includes(submitText.toLowerCase())) {
        window.open(`https://www.procure.lorri.in`, "_blank")
      }
      else {
        if (val) {
          if (val.transporter_id !== undefined && from === 'autocomplete') {
            const a = document.createElement("a")
            a.href = `https://company.lorri.in/tpmp/${encryptor(val.transporter_id, true)}`
            a.target = "_blank"
            a.rel = "noopener"
            a.click()
            // window.open(`${window.location.origin}/tpmp/${encryptor(val.transporter_id, true)}`, "_blank", "noopener")
          }
          else {
            setShow(true)
            // Axios.post("https://lorrisearchv2.azurewebsites.net/api/lorrisearch", {
            Axios.post(`${Urls.search_results}`, {
              "text": val && val.location_name ? val.location_name.split(",")[0] : val.name ? val.name : submitText,
              // "coordinates_found": [val.location]              
            })
              .then(res => {
                // console.log(res.data)
                props.history.push({
                  pathname: '/SearchResults',
                  state: { data: res.data.data, searchquery: val ? val.location_name : submitText }
                });
                setShow(false)
              })
              .catch(err => {
                console.log(err)
                setShow(false)
              })
          }
        }
        else {
          setShow(true)
          if (submitText) {
            // console.log(val)
            // Axios.post("https://lorrisearchv2.azurewebsites.net/api/lorrisearch", {
            Axios.post(`${Urls.search_results}`, {
              "text": val ? val.location_name : submitText
            })
              .then(res => {
                // console.log(res.data)
                props.history.push({
                  pathname: '/SearchResults',
                  state: { data: res.data.data, searchquery: val ? val.location_name : submitText }
                });
                // setdata(res.data.data)
                setShow(false)
              })
              .catch(err => {
                console.log(err)
                setShow(false)
              })
          }
          else {
            setShow(false)
            toast.info('Search results cannot be empty')
          }
        }
      }
    }
  };

  const onRaitingClick = () => {
    props.history.push({
      pathname: '/myTransporters',
      state: { formId: null }
    });
  };
  // const openJotform = e => {
  //   window.open(`https://form.jotform.me/91711130242442`, '_blank');
  //   e.preventDefault();
  // };
  // const ApplyMultiple = (e) => {
  //   setSearchText(e);

  // }
  // const searchEnter = (e) => {
  //   // console.log(e)

  //   if (e.key === 'Enter') {

  //     // Cancel the default action, if needed
  //     e.preventDefault();
  //     // Trigger the button element with a click
  //     document.getElementById("searchSubmit").click();
  //   }
  // }
  // const changeHandler = (e) => {
  //   // console.log(e)
  //   setsubmitText(e.target.value)
  // }
  // const startRecording = (e) => {
  //   setTimeout(() => {
  //     SpeechRecognition.stopListening()
  //     setmikeColor(false)
  //   }, 10000);
  //   setmikeColor(true)
  //   SpeechRecognition.startListening()
  //   setaudio_input(true)

  // }
  return (
    <>
      {(show === true) ? (<Loader show={show} message="Loading Details" />) : (
        <>
          {(isAllowed === 'yes') ? (
            <div style={{ overflowY: "hidden" }} className="">
              <div style={{ height: "100vh", backgroundImage: "linear-gradient(to right, #d3d4d6, #fafafc, white , #e5e3e4)" }} className="main-search-container centered">
                <div className="main-search-inner">
                  <div className="container ">
                    <div className="row">
                      <div className="col-md-12 Home__main-container">
                        {/* <div> */}
                        <img alt="img" src={LoRRI_Image} className="s-img1" />
                        {/* </div> */}
                        {/* <h3 className='Home__title-text'>LOGISTICS INTELLIGENCE PLATFORM </h3> */}
                        <h6>
                          <TypingEffect
                            text={typedWords}
                            className="typed-words margin-bottom-70 Home__title-text"
                            speed={50}
                            eraseDelay={10}
                          />
                        </h6>

                        <div className="main-search-input margin-bottom-70">
                          {/* <div className="main-search-input-item search-zone-select">
                            <ReactFlagsSelect
                              countries={Countries.map(c => c.code)}
                              onSelect={countryCode =>
                                setCountry(
                                  Countries.filter(c => c.code === countryCode)[0].name
                                )
                              }
                              defaultCountry="IN"
                            />
                          </div> */}

                          <div style={{ border: "none" }} className="main-search-input-item flex-1">
                            {/* <Autosuggestor value={submitText} onChange={(e) => setsubmitText(e)} country={country} onSelect={e => setsubmitText(e)} getResults={e => onSearchSubmit(e, "autocomplete")} /> */}
                            <Autosuggestor value={submitText} onChange={(e) => setsubmitText(e)} onSelect={e => setsubmitText(e)} getResults={e => onSearchSubmit(e, "autocomplete")} />
                            {/* {audio_input ?
                              <input value={transcript} type="text" placeholder="Search here" onChange={e => changeHandler(e)}
                              onKeyDown={e => searchEnter(e)}
                              />
                              :
                              <input type="text" placeholder="Search here" onChange={e => changeHandler(e)}
                                //  tabIndex="0" 
                                // onKeyDownCapture={e => searchEnter(e)} 
                                onKeyDown={e => searchEnter(e)}
                              />
                            } */}
                          </div>

                          {/* <button
                            id="zoneSubmit"
                            className={!mikeColor ? "button margin-0 border-none" : "button btn-success margin-0 border-none"}
                            onClick={e => startRecording()}
                            style={{ borderRight: 'solid 1px black' }}
                          >
                            <i className="fas fa-microphone"></i>

                          </button> */}
                          {/* <button
                            id="searchSubmit"
                            className="button margin-0 border-none"
                            onClick={e => onSearchSubmit()}
                          >
                            <i className="fas fa-search"></i>

                          </button> */}
                        </div>
                        {/* <button
                   className="button background-color-blue border-radius-50"
                   onClick={() =>
                     props.history.push({
                       pathname: '/TransporterRatingsForm',
                       state: { formId: '91220520733445' }
                     })
                   }
                 >
                   Rate Your Transporters
                 </button> */}
                        {/*Action button for jotform*/}
                        <div>
                          <button id="searchSubmit" className="btn btn-primary searchSubmit"
                            // className="buttonRate"
                            //    https://{s}.tile.openstreetmap.de/tiles/osmde/{z}/{x}/{y}.png
                            onClick={e => onSearchSubmit()}
                          >
                            <span>
                              <i style={{ marginRight: "2%" }} className="fas fa-search"></i>
                              Search
                            </span>

                          </button>
                          <button
                            // className="buttonRate"
                            className="btn btn-primary rateNow"
                            // onClick={openJotform}
                            onClick={() => onRaitingClick()}
                          >
                            <span>Rate Now !</span>
                          </button>
                        </div>
                      </div>
                      {/* <div>
                        <button
                          className="buttonRate"
                          style={{marginLeft:"174%"}}
                          // onClick={openJotform}
                          onClick={() => onRaitingClick()}
                        >
                          <span>Rate Your Transporters Now!</span>
                        </button>
                      </div> */}
                    </div>

                    <div className="row" style={{ marginTop: '4%' }}>
                      <div className="col-md-3">
                        <a
                          href="https://company.lorri.in/BenchmarkNow"
                          target="_blank"
                          id='benchmark-link'
                          rel="noopener noreferrer"
                          onclick="logapi('Already Rated page from Email Rating', 'LoRRI', 'Clicked on Benchmark')"
                        >
                          <img alt='bn' src="https://aboutlorri.blob.core.windows.net/mail/benchmark.png" className="dot"></img>
                          <br />
                          <div className="des">Get benchmark for your lanes</div>
                        </a>
                      </div>
                      <div className="col-md-3">
                        <a
                          href="https://company.lorri.in/indents"
                          target="_blank"
                          id='benchmark-link'
                          rel="noopener noreferrer"
                          onclick="logapi('Already Rated page from Email Rating', 'LoRRI', 'Clicked on Indents')"
                        >
                          <img alt='bn' src="https://aboutlorri.blob.core.windows.net/mail/indents.png" className="dot" style={{ width: '39%' }}></img>
                          <br />
                          <div className="des">Create & manage indents and track your vehicles</div>
                        </a>
                      </div>
                      <div className="col-md-3">
                        <a
                          href="https://procurement.lorri.in/auction"
                          target="_blank"
                          id='benchmark-link'
                          rel="noopener noreferrer"
                          onclick="logapi('Already Rated page from Email Rating', 'LoRRI', 'Clicked on auction')"
                        >
                          <img alt='bn' src="https://aboutlorri.blob.core.windows.net/mail/auction.png" className="dot" style={{ width: '39%' }}></img>
                          <br />
                          <div className="des">Run contracted and spot procurements with end-to-end auction</div>
                        </a>
                      </div>
                      <div className="col-md-3">
                        <a
                          href="https://company.lorri.in/myTransporters"
                          target="_blank"
                          id='benchmark-link'
                          rel="noopener noreferrer"
                          onclick="logapi('Already Rated page from Email Rating', 'LoRRI', 'Clicked on RateNow (myTransporters)')"
                        >
                          <img alt='bn' src="https://aboutlorri.blob.core.windows.net/mail/transporter.png" className="dot" style={{ width: '37%' }}></img>
                          <br />
                          <div className="des" style={{ marginTop: '2%' }}>Find best fit transporters for your plants</div>
                        </a>
                      </div>
                    </div>

                    {/* Features Categories */}

                    {/* Featured Categories - End */}
                  </div>
                </div>
                {/* Video */}

                <div className="background-image-container search-input-container" />
              </div>
              {/*
     <div className="display-flex floating-tiles">
         <div className="image-container">
           <img src={BenchmarkLogo} alt="Benchmark Logo" />
           <label>
             <b>Discover Industry Benchmarks</b>
           </label>
         </div>{' '}
         <div className="image-container">
           <img src={RightPartner} alt="Right Partner Logo" />
           <label>
             <b>Select the Right Logistics Partner</b>
           </label>
         </div>{' '}
         <div className="image-container">
           <img src={Multimodal} alt="Multimodal Logo" />
           <label>
             <b>Explore Multi-modal Options</b>
           </label>
         </div>{' '}
       </div> */}
              {/* Content
 ================================================== */}

            </div>
          ) : (<div className="Auth_message">
            <Unauthorized message='Your subscription does not include this service' />

          </div>
          )}
        </>
      )}

    </>

  );
};

export default withRouter(Home);
